import scrollPositionMixin from './scrollPositionMixin'
import mediaQueryMixin from './mediaQueryMixin'
import { trackChapter } from '@/utils/track'

export default {
  name: 'Chapter',
  props: {
    track: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tracked: false
    }
  },
  mixins: [scrollPositionMixin, mediaQueryMixin],
  watch: {
    reached () {
      if (!this.tracked) {
        trackChapter(this.track)
        this.tracked = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chapterMixin.js